import * as React from 'react';



export default class SingleLayout extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16"  className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" strokeWidth="1" fillRule="evenodd">
            <g transform="translate(1 2)" id="singleLayout" stroke="#878787">
                <path stroke="" strokeLinecap="round" d="M.538 1.615h12.924"/>
                <path stroke="none" id="selected" fill="#43adf1" d="M12 4h1v7h-1z"/>
                <rect width="13" height="7.615" x=".5" y="3.731" stroke="" rx="1"/>
            </g>
        </g>
      </svg>
    )
  }
}
